@tailwind base;
@tailwind components;
@tailwind utilities;

:root {
  font-family:
    system-ui,
    -apple-system,
    'Segoe UI',
    Roboto,
    'Helvetica Neue',
    Arial,
    sans-serif;
}

body {
  margin: 0;
  min-width: 320px;
}

svg {
  width: 1.5rem;
  height: 1.5rem;
  display: inline-block;
  vertical-align: middle;
}
